<template>
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
    background-color="#1e1e1e" text-color="#a8a7a9" active-text-color="#eb602e">
        <el-menu-item index="0">
            <div class="el-menu-logo">
                <img class="el-menu-logo-img" :src="logoImg" type="image/svg+xml">
                <!-- <i><img class="el-menu-logo-img" :src="logoImg" type="image/svg+xml"></i> -->
            </div>
        </el-menu-item>
        <el-menu-item index="1">主页</el-menu-item>
        <el-menu-item index="4" style="float: right;">
            <el-dropdown>
                <a class="dropdown-item login">{{userName}}</a>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="loginOut">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-menu-item>
    </el-menu>
</template>

<script>
import { mapState } from "vuex";
import { post } from "@/api/index";

export default {
    data: function () {
        return {
            activeIndex: '1',
            logoImg: require("@/assets/img/lianghualogo.svg"),
        }
    },
    computed: {
        ...mapState([
            "token",
            "userName"
        ])
    },
    methods: {
        loginOut() {
            // this.passwordDialog = true;

            if (this.token) {
                 var url =  this.$baseUrl + '/user/logout';
                var param = {
                    'token': this.token
                };

                post(url, param).then(res => {
                    if (res.code == 200) {

                        this.$cookies.remove('token');
                        this.$cookies.remove('userName');
                        this.$cookies.remove('isSuper');
                        
                        this.$notify.info({
                            message: res.info,
                            title: '提示',
                            offset: 100
                        })

                        this.$router.push('/login');
                    } else {
                        this.$notify.error({
                            message: res.info,
                            title: '提示',
                            offset: 100
                        })
                    }

                })
            } else {
                this.$router.push('/login');
            }

        }
    }
}
</script>

<style lang="scss">
.el-menu-demo {
    border-bottom: 0 !important;
    color: #a8a7a9;
    .el-menu-logo{
        .el-menu-logo-img {
            width: 100px;
        }
    }
}
</style>

